<form [formGroup]="tipoTramiteForm">
	<main class="grid formgrid p-fluid">
		<div class="field col-12">
			<label for="descripcion" class="ml-3">{{'common.nombre' | translate}}<span style="color: red">*</span></label>
			<input pInputText formControlName="descripcion" id="descripcion" type="text" />
			<ng-container *ngIf="tipoTramiteForm.get('descripcion')?.invalid && tipoTramiteForm.get('descripcion')?.touched">
				<app-form-group-error-message [control]="tipoTramiteForm.get('descripcion')"></app-form-group-error-message>
			</ng-container>
		</div>
		<div class="field col-12 flex flex-column">
			<label class="ml-3" for="descripcionBreve">Descripcion breve del trámite o servicio<span
					style="color: red">*</span></label>
			<textarea rows="5" cols="60" pInputTextarea formControlName="descripcionBreve"></textarea>
			<ng-container
				*ngIf="tipoTramiteForm.get('descripcionBreve')?.invalid && tipoTramiteForm.get('descripcionBreve')?.touched">
				<app-form-group-error-message
					[control]="tipoTramiteForm.get('descripcionBreve')"></app-form-group-error-message>
			</ng-container>
		</div>
		<div class="field col-12 md:col-6">
			<label for="controlDeTiempoId" class="ml-3">{{'common.controlDeTiempo' | translate}}<span
					style="color: red">*</span></label>
			<p-dropdown [options]="controlTiempos" formControlName="controlDeTiempoId" appendTo="body" [placeholder]="('common.select' | translate) + '...'"
				optionLabel="nombre" optionValue="id" autoWidth="false" [style]="{'width':'100%'}">
			</p-dropdown>
      <small *ngIf="controlTiempoVersionNotLatest" class="p-error block">
        {{'common.noUltimaVersion' | translate}}
      </small>
			<ng-container *ngIf="tipoTramiteForm.get('controlDeTiempoId')?.invalid && tipoTramiteForm.get('controlDeTiempoId')?.dirty">
				<app-form-group-error-message [control]="tipoTramiteForm.get('controlDeTiempoId')"></app-form-group-error-message>
			</ng-container>
		</div>
		<div class="field col-12 md:col-6">
			<label class="ml-3" for="requierePago">{{'msg.tramiteRequierePago' | translate}}<span
					style="color: red">*</span></label>
			<p-dropdown [options]="requierePagoOptions" formControlName="requierePago" appendTo="body" [placeholder]="('common.select' | translate) + '...'"
				optionLabel="nombre" optionValue="id" autoWidth="false" [style]="{'width':'100%'}">
			</p-dropdown>
			<ng-container *ngIf="tipoTramiteForm.get('requierePago')?.invalid && tipoTramiteForm.get('requierePago')?.dirty">
				<app-form-group-error-message [control]="tipoTramiteForm.get('requierePago')"></app-form-group-error-message>
			</ng-container>
		</div>

		<div class="field col-12 md:col-6">
			<label for="categorizacionId" class="ml-3">{{'fields.tipo-tramite.categorizacion' | translate}}<span
					style="color: red">*</span></label>
			<div class="flex gap-1 justify-content-start">
				<p-dropdown [options]="categorizaciones" formControlName="categorizacionId" appendTo="body"
					[placeholder]="'fields.tipo-tramite.categorizacion' | translate" autoWidth="false" [style]="{'width':'100%', 'height':'3rem'}"
					optionValue="id" optionLabel="descripcion" [filter]="true" class="flex-grow-1 min-w-0"></p-dropdown>
				<button pButton type="button" (click)="getCategorizaciones()" icon="pi pi-refresh"
					class="p-button-success" style="height: 3rem; min-width: 3rem;"></button>
				<button pButton type="button" (click)="openLink(2)" icon="pi pi-plus" class="p-button-help" style="height: 3rem; min-width: 3rem;"></button>
			</div>
			<ng-container
				*ngIf="tipoTramiteForm.get('categorizacionId')?.invalid && tipoTramiteForm.get('categorizacionId')?.dirty">
				<app-form-group-error-message
					[control]="tipoTramiteForm.get('categorizacionId')"></app-form-group-error-message>
			</ng-container>
		</div>
		<div class="field col-12 md:col-6">
			<label class="ml-3" for="dependenciaId">{{'fields.tipo-tramite.dependencias' | translate}}<span
					style="color: red">*</span></label>
			<div class="flex gap-1 justify-content-start">
				<p-dropdown [options]="dependencias" formControlName="dependenciaId" appendTo="body"
					[placeholder]="'fields.tipo-tramite.dependencias' | translate" autoWidth="false" [style]="{'width':'100%', 'height':'3rem'}"
					optionValue="id" optionLabel="descripcion" [filter]="true" class="flex-grow-1 min-w-0">
				</p-dropdown>
				<button pButton type="button" (click)="getDependencias()" icon="pi pi-refresh"
					class="p-button-success" style="height: 3rem; min-width: 3rem;"></button>
				<button pButton type="button" (click)="openLink(1)" icon="pi pi-plus" class="p-button-help" style="height: 3rem; min-width: 3rem;"></button>
			</div>
			<ng-container
				*ngIf="tipoTramiteForm.get('dependenciaId')?.invalid && tipoTramiteForm.get('dependenciaId')?.dirty">
				<app-form-group-error-message [control]="tipoTramiteForm.get('dependenciaId')"></app-form-group-error-message>
			</ng-container>
		</div>
		<div class="field col-12 md:col-6">
			<label for="formularioId" class="ml-3">{{'fields.tipo-tramite.formulario' | translate}}<span
					style="color: red">*</span></label>
			<div class="flex gap-1 justify-content-start">
				<p-dropdown [options]="formularios" formControlName="formularioId" appendTo="body" placeholder="Select"
					optionLabel="nombre" optionValue="id" autoWidth="false" [style]="{'width':'100%', 'height':'3rem'}" [filter]="true"
					class="flex-grow-1 min-w-0">
				</p-dropdown>
				<button pButton type="button" (click)="getFormularios()" icon="pi pi-refresh" class="p-button-success" style="height: 3rem; min-width: 3rem;"></button>
				<button pButton type="button" (click)="openLink(3)" icon="pi pi-plus" class="p-button-help" style="height: 3rem; min-width: 3rem;"></button>
			</div>
        <small *ngIf="formularioVersionNotLatest" class="p-error block">
          {{'common.noUltimaVersion' | translate}}
        </small>
			<ng-container *ngIf="tipoTramiteForm.get('formularioId')?.invalid && tipoTramiteForm.get('formularioId')?.dirty">
				<app-form-group-error-message [control]="tipoTramiteForm.get('formularioId')"></app-form-group-error-message>
			</ng-container>
		</div>
		<div class="field col-12 md:col-6 container-checkbox">
			<div class="flex align-items-center gap-2">
				<label for="asignacionManual" class="label-text block ml-3">{{'msg.asignacionManual' | translate}}</label>
			</div>
			<p-checkbox [binary]="true" formControlName="asignacionManual" inputId="binary"></p-checkbox>
		</div>
    <div class="field col-12 md:col-6">
			<label class="ml-3" for="dirigidoTramiteIds">{{'msg.aQuienEstaDirigidoElTramite' | translate}}<span
					style="color: red">*</span></label>
			<p-multiSelect [options]="dirigidoTramite" formControlName="dirigidoTramiteIds" optionLabel="nombre"
				optionValue="id" [placeholder]="('common.select' | translate) + '...'" [style]="{'width':'100%'}" appendTo="body" showHeader="false">
			</p-multiSelect>
			<ng-container
				*ngIf="tipoTramiteForm.get('dirigidoTramiteIds')?.invalid && tipoTramiteForm.get('dirigidoTramiteIds')?.dirty">
				<app-form-group-error-message
					[control]="tipoTramiteForm.get('dirigidoTramiteIds')"></app-form-group-error-message>
			</ng-container>
		</div>
    <div class="field col-12 md:col-6">
			<label class="ml-3" for="componentPersonalizado">{{'common.componentePersonalizado' | translate}}        
      </label>
      <p-dropdown [options]="componentsPersonalizados" formControlName="componentPersonalizado" appendTo="body" 
        [placeholder]="('common.select' | translate) + '...'" [showClear]="true"
				optionLabel="nombre"autoWidth="false" [style]="{'width':'100%'}">
			</p-dropdown>
      <div>
        <small *ngIf="formComponentPersonalizado && !formComponentPersonalizado.isLatest"
          class="p-error block">
          {{'common.noUltimaVersion' | translate}}
        </small>
      </div>
			<ng-container
				*ngIf="tipoTramiteForm.get('componentPersonalizado')?.invalid && tipoTramiteForm.get('componentPersonalizado')?.dirty">
				<app-form-group-error-message
					[control]="tipoTramiteForm.get('componentPersonalizado')"></app-form-group-error-message>
			</ng-container>
		</div>

    @if(requierePago){
      <p-panel [header]="'msg.configuracionDePago' | translate" class="w-full pb-1" [toggleable]="true"
        [collapsed]="false">
        <div class="grid formgrid p-fluid"> 
          <div class="field col-12 md:col-6">
            <label for="conceptosTramitesId" class="ml-3">
              {{'common.fuenteDePago' | translate}}
            </label>
            <p-dropdown [options]="conceptosTramites" formControlName="conceptosTramitesId" appendTo="body"
              [placeholder]="('common.select' | translate) + '...'" optionLabel="descripcion" optionValue="id" autoWidth="false" [style]="{'width':'100%'}"
              [showClear]="true" filter="true" filterBy="descripcion">
            </p-dropdown>
            <ng-container
              *ngIf="tipoTramiteForm.get('conceptosTramitesId')?.invalid && tipoTramiteForm.get('conceptosTramitesId')?.dirty">
              <app-form-group-error-message
                [control]="tipoTramiteForm.get('conceptosTramitesId')"></app-form-group-error-message>
            </ng-container>
          </div>
          <div class="field col-12 md:col-6 flex flex-column">
            <label class="ml-3" for="iac">
              {{'common.iac' | translate}}
            </label>
            <p-inputMask formControlName="iac" mask="9999999999999" placeholder="0000000000000" />
            <ng-container *ngIf="tipoTramiteForm.get('iac')?.invalid && tipoTramiteForm.get('iac')?.touched">
              <app-form-group-error-message [control]="tipoTramiteForm.get('iac')"></app-form-group-error-message>
            </ng-container>
          </div>
          <div class="col-12">
            <h4 class="text-center">Cuenta en la que se realiza el pago del trámite</h4>
          </div>
          <div class="field col-12 md:col-4">
            <label class="ml-3" for="tipoCuenta">Tipo de cuenta<span style="color: red">*</span></label>
            <input pInputText formControlName="tipoCuenta" id="tipoCuenta" type="text" style="width: 100%" />
            <ng-container *ngIf="tipoTramiteForm.get('tipoCuenta')?.invalid && tipoTramiteForm.get('tipoCuenta')?.touched">
              <app-form-group-error-message [control]="tipoTramiteForm.get('tipoCuenta')"></app-form-group-error-message>
            </ng-container>
          </div>
          <div class="field col-12 md:col-4">
            <label class="ml-3" for="nombreBanco">Nombre del banco<span style="color: red">*</span></label>
            <input pInputText formControlName="nombreBanco" id="nombreBanco" type="text" style="width: 100%" />
            <ng-container *ngIf="tipoTramiteForm.get('nombreBanco')?.invalid && tipoTramiteForm.get('nombreBanco')?.touched">
              <app-form-group-error-message [control]="tipoTramiteForm.get('nombreBanco')"></app-form-group-error-message>
            </ng-container>
          </div>
          <div class="field col-12 md:col-4">
            <label class="ml-3" for="numeroCuenta">Numero<span style="color: red">*</span></label>
            <input pInputText formControlName="numeroCuenta" id="numeroCuenta" type="text" style="width: 100%" />
            <ng-container
              *ngIf="tipoTramiteForm.get('numeroCuenta')?.invalid && tipoTramiteForm.get('numeroCuenta')?.touched">
              <app-form-group-error-message [control]="tipoTramiteForm.get('numeroCuenta')"></app-form-group-error-message>
            </ng-container>
          </div>
        </div>        
      </p-panel>
    }

    <p-panel [header]="'common.informacionComplementaria' | translate" class="w-full pb-1" [toggleable]="true"
			[collapsed]="false">
      <div class="grid formgrid p-fluid">
        <div class="field col-12 lg:col-6">
          <label class="ml-3" for="urlTramite">Url del Trámite</label>
          <input pInputText formControlName="urlTramite" id="urlTramite" type="text" style="width: 100%" />
          <ng-container *ngIf="tipoTramiteForm.get('urlTramite')?.invalid && tipoTramiteForm.get('urlTramite')?.touched">
            <app-form-group-error-message [control]="tipoTramiteForm.get('urlTramite')"></app-form-group-error-message>
          </ng-container>
        </div>
        <div class="field col-12 md:col-6">
          <label class="ml-3" for="canalAtencionIds">Canal de Atencion del Trámite<span style="color: red">*</span></label>
          <p-multiSelect [options]="canalesAtencion" formControlName="canalAtencionIds" optionLabel="nombre"
            optionValue="id" [placeholder]="('common.select' | translate) + '...'" [style]="{'width':'100%'}" appendTo="body" showHeader="false">
          </p-multiSelect>
          <ng-container
            *ngIf="tipoTramiteForm.get('canalAtencionIds')?.invalid && tipoTramiteForm.get('canalAtencionIds')?.dirty">
            <app-form-group-error-message
              [control]="tipoTramiteForm.get('canalAtencionIds')"></app-form-group-error-message>
          </ng-container>
        </div>
        <div class="field col-12 md:col-6">
          <label class="ml-3" for="enfoqueDiferencialIds">Enfoque Diferencial<span style="color: red">*</span></label>
          <p-multiSelect [options]="enfoqueDiferencial" formControlName="enfoqueDiferencialIds" optionLabel="nombre"
            optionValue="id" [placeholder]="('common.select' | translate) + '...'" [style]="{'width':'100%'}" appendTo="body" showHeader="false">
          </p-multiSelect>
          <ng-container
            *ngIf="tipoTramiteForm.get('enfoqueDiferencialIds')?.invalid && tipoTramiteForm.get('enfoqueDiferencialIds')?.dirty">
            <app-form-group-error-message
              [control]="tipoTramiteForm.get('enfoqueDiferencialIds')"></app-form-group-error-message>
          </ng-container>
        </div>
        <div class="field col-12 md:col-6">
          <label class="ml-3" for="caracteristicaEspecialIds">Caracteristicas especiales de las personas a la cual va
            dirigido el tramite<span style="color: red">*</span></label>
          <p-multiSelect [options]="caracteristicasEspeciales" formControlName="caracteristicaEspecialIds"
            optionLabel="nombre" optionValue="id" [placeholder]="('common.select' | translate) + '...'" [style]="{'width':'100%'}" appendTo="body"
            showHeader="false">
          </p-multiSelect>
          <ng-container
            *ngIf="tipoTramiteForm.get('caracteristicaEspecialIds')?.invalid && tipoTramiteForm.get('caracteristicaEspecialIds')?.dirty">
            <app-form-group-error-message
              [control]="tipoTramiteForm.get('caracteristicaEspecialIds')"></app-form-group-error-message>
          </ng-container>
        </div>
        <div class="field col-12 md:col-6">
          <label class="ml-3" for="periodo">Fechas o periodos en que debe realizarse el trámite<span
              style="color: red">*</span></label>
          <input pInputText formControlName="periodo" id="periodo" type="text" style="width: 100%" />
          <ng-container *ngIf="tipoTramiteForm.get('periodo')?.invalid && tipoTramiteForm.get('periodo')?.touched">
            <app-form-group-error-message [control]="tipoTramiteForm.get('periodo')"></app-form-group-error-message>
          </ng-container>
        </div>
        <div class="field col-12 md:col-6">
          <label class="ml-3" for="horariosAtencion">Horarios de atencion del trámite<span
              style="color: red">*</span></label>
          <input pInputText formControlName="horariosAtencion" id="horariosAtencion" type="text" style="width: 100%" />
          <ng-container
            *ngIf="tipoTramiteForm.get('horariosAtencion')?.invalid && tipoTramiteForm.get('horariosAtencion')?.touched">
            <app-form-group-error-message
              [control]="tipoTramiteForm.get('horariosAtencion')"></app-form-group-error-message>
          </ng-container>
        </div>
        <div class="field col-12 flex flex-column">
          <label class="ml-3" for="requisitos">Requisitos para la realizacion del trámite<span
              style="color: red">*</span></label>
          <textarea rows="5" cols="60" pInputTextarea formControlName="requisitos"></textarea>
          <ng-container *ngIf="tipoTramiteForm.get('requisitos')?.invalid && tipoTramiteForm.get('requisitos')?.touched">
            <app-form-group-error-message [control]="tipoTramiteForm.get('requisitos')"></app-form-group-error-message>
          </ng-container>
        </div>
        <div class="field col-12 flex flex-column">
          <label class="ml-3" for="ruta">Ruta del tramite<span style="color: red">*</span></label>
          <textarea rows="5" cols="60" pInputTextarea formControlName="ruta"></textarea>
          <ng-container *ngIf="tipoTramiteForm.get('ruta')?.invalid && tipoTramiteForm.get('ruta')?.touched">
            <app-form-group-error-message [control]="tipoTramiteForm.get('ruta')"></app-form-group-error-message>
          </ng-container>
        </div>
        <div class="field col-12">
          <label class="ml-3" for="relacion">Relacion del trámite con otros trámites<span
              style="color: red">*</span></label>
          <input pInputText formControlName="relacion" id="relacion" type="text" style="width: 100%" />
          <ng-container *ngIf="tipoTramiteForm.get('relacion')?.invalid && tipoTramiteForm.get('relacion')?.touched">
            <app-form-group-error-message [control]="tipoTramiteForm.get('relacion')"></app-form-group-error-message>
          </ng-container>
        </div>
        <div class="field col-12">
          <label class="ml-3" for="norma">Norma que regula el trámite<span style="color: red">*</span></label>
          <input pInputText formControlName="norma" id="norma" type="text" style="width: 100%" />
          <ng-container *ngIf="tipoTramiteForm.get('norma')?.invalid && tipoTramiteForm.get('norma')?.touched">
            <app-form-group-error-message [control]="tipoTramiteForm.get('norma')"></app-form-group-error-message>
          </ng-container>
        </div>
        <div class="field col-12 md:col-4">
          <label class="ml-3" for="direccion">{{'common.direccion' | translate}}<span style="color: red">*</span></label>
          <input pInputText formControlName="direccion" id="direccion" type="text" style="width: 100%" />
          <ng-container *ngIf="tipoTramiteForm.get('direccion')?.invalid && tipoTramiteForm.get('direccion')?.touched">
            <app-form-group-error-message [control]="tipoTramiteForm.get('direccion')"></app-form-group-error-message>
          </ng-container>
        </div>
        <div class="field col-12 md:col-4">
          <label class="ml-3" for="telefono">{{'common.telefono' | translate}}<span style="color: red">*</span></label>
          <input pInputText formControlName="telefono" id="telefono" type="text" style="width: 100%" />
          <ng-container *ngIf="tipoTramiteForm.get('telefono')?.invalid && tipoTramiteForm.get('telefono')?.touched">
            <app-form-group-error-message [control]="tipoTramiteForm.get('telefono')"></app-form-group-error-message>
          </ng-container>
        </div>
        <div class="field col-12 md:col-4">
          <label class="ml-3" for="correo">{{'common.correo' | translate}}<span style="color: red">*</span></label>
          <input pInputText formControlName="correo" id="correo" type="text" style="width: 100%" />
          <ng-container *ngIf="tipoTramiteForm.get('correo')?.invalid && tipoTramiteForm.get('correo')?.touched">
            <app-form-group-error-message [control]="tipoTramiteForm.get('correo')"></app-form-group-error-message>
          </ng-container>
        </div>
        <div class="field col-12 flex flex-column">
          <label class="ml-3" for="observaciones">{{'common.observaciones' | translate}}</label>
          <textarea rows="5" cols="60" pInputTextarea formControlName="observaciones"></textarea>
          <ng-container
            *ngIf="tipoTramiteForm.get('observaciones')?.invalid && tipoTramiteForm.get('observaciones')?.touched">
            <app-form-group-error-message [control]="tipoTramiteForm.get('observaciones')"></app-form-group-error-message>
          </ng-container>
        </div>
      </div>
    </p-panel>

		<p-panel [header]="'msg.configuracionFirmaComprobante' | translate" class="w-full pb-1" [toggleable]="true"
			[collapsed]="true">
			<div class="grid formgrid p-fluid">
				<div class="field col-12 md:col-6">
					<label class="ml-3" for="nombreFirmante">{{'msg.nombreFirmante' | translate}}</label>
					<input pInputText formControlName="nombreFirmante" id="nombreFirmante" type="text" style="width: 100%" />
					<ng-container
						*ngIf="tipoTramiteForm.get('nombreFirmante')?.invalid && tipoTramiteForm.get('nombreFirmante')?.touched">
						<app-form-group-error-message
							[control]="tipoTramiteForm.get('nombreFirmante')"></app-form-group-error-message>
					</ng-container>
				</div>
				<div class="field col-12 md:col-6 flex flex-column">
					<label class="ml-3">{{'msg.firmaAprobacion' | translate}}</label>

					@if(tipoTramiteForm.get('tieneFirmaComprobante')?.value && !firmaDeComprobante) {
					<button pButton type="button" (click)="removerFirmaArchivo()" icon="pi pi-trash"
						label="Remover Firma Comprobante" class="p-button-danger"></button>
					}@else {
					<div class="flex">
						<p-fileUpload #fileUpload mode="basic" accept="image/*" [maxFileSize]="uploadFileSize"
							[chooseLabel]="'msg.agregarDocumento' | translate" [customUpload]="true" [auto]="true"
							chooseIcon="pi pi-upload" (uploadHandler)="uploadFirmaHandler($event, fileUpload)"></p-fileUpload>
						<button pButton icon="pi pi-trash" class="p-button-cancel-fileupload cancel border-noround-left	"
							(click)="removerFirmaArchivo()" [disabled]="!firmaDeComprobante"></button>
					</div>

					@if (invalidSize) {
					<small class="p-error block">
						<strong>{{ firmaDeComprobante?.name }}</strong>: {{ "form.msg.invalid-size" | translate }} </small>
					} @else if (firmaDeComprobante?.size && !invalidSize) {
					<small class="text-gray-700 block"> {{ firmaDeComprobante?.name }} </small>
					}
					}
				</div>
			</div>
		</p-panel>

		<p-panel [header]="'msg.configuraciónRespuestaDinámica' | translate" class="w-full pb-1" [collapsed]="true"
			[toggleable]="true">
			<div class="grid formgrid p-fluid">
				<div class="field col-12 md:col-12">
					<label for="tipoId" class="ml-3">{{'components.app-correo-plantilla.title-table' | translate}}</label>
					<div class="flex gap-1 justify-content-start">
						<p-dropdown [options]="correosTemplate" formControlName="correoPlantillaId" appendTo="body"
							optionLabel="nombre" optionValue="id" autoWidth="false" class="flex-grow-1" [filter]="true"
							[placeholder]="('common.select' | translate) + '...'"
							[showClear]="true" (onClear)="oncorreoPlantillaIdClear($event)">
						</p-dropdown>
					</div>
          <small *ngIf="correoPlantillaVersionNotLatest" class="p-error block">
            {{'common.noUltimaVersion' | translate}}
          </small>
					<ng-container *ngIf="tipoTramiteForm.get('correoPlantillaId')?.invalid && 
						tipoTramiteForm.get('correoPlantillaId')?.dirty">
						<app-form-group-error-message [control]="tipoTramiteForm.get('correoPlantillaId')">
						</app-form-group-error-message>
					</ng-container>
				</div>
				<div class="field col-12 md:col-12">
					<app-configuracion-llaves [showDelete]="false"></app-configuracion-llaves>
				</div>
			</div>
		</p-panel>
	</main>
</form>